// extracted by mini-css-extract-plugin
export default {"hostedPageFrame":"PowerTranzCheckout_hostedPageFrame__6lUTy"};